export type FormMode = 'add' | 'view' | 'edit';

export interface GeoCoordinateModel {
  latitude: number | string;
  longitude: number | string;
}

export interface LandFormModel {
  name: string;
  name_ar: string;
  region: number | null;
  real_estate_type_categories_id: number | null;
  city_id: number | null;
  district_id: number | null;
  area: number | null;
  reference: string;
  land_purchase: number | null;
  lat: string;
  lng: string;
  geoFenceCoordinates: GeoCoordinateModel[];
  asset_type_detail: Record<string, unknown>;
}

export function createEmptyLandFormModel(): LandFormModel {
  return {
    name: '',
    name_ar: '',
    region: null,
    real_estate_type_categories_id: null,
    city_id: null,
    district_id: null,
    area: null,
    reference: '',
    land_purchase: null,
    lat: '',
    lng: '',
    geoFenceCoordinates: [],
    asset_type_detail: {},
  };
}

export function createDefaultCoordinates(count = 4): GeoCoordinateModel[] {
  return Array.from({ length: count }, () => ({ latitude: '', longitude: '' }));
}
